import {getApi} from "../../data/ApiService";


const state = {
    block_features:[],
    products: [
        // {
        //     pr: 'ملات عایق حرارت',
        //     en: 'Heat Resistant Plaster',
        //     img: require('@/assets/images/light_blocks_products/heat.jpeg'),
        //     url: 'topic/295',
        // },
        {
            pr: 'ملات اندودکاری (آستر)',
            en: 'Plaster Mortar',
            img: require('@/assets/images/mortar/plaster-mortar.jpg'),
            url: 'topic/294',
        },
        {
            pr: 'ملات خود تراز شونده',
            en: 'Self-leveling Mortar',
            img: require('@/assets/images/mortar/self-leveling.jpg'),
            url: 'topic/293',
        },
        {
            pr: 'چسب بلوک سبک AAC',
            en: 'AAC',
            img: require('@/assets/images/mortar/AAC.jpg'),
            url: 'topic/292',
        },
        // {
        //     pr: 'ملات ضد حریق',
        //     en: 'Fireproof Mortar',
        //     img: require('@/assets/images/mortar/jpeg'),
        //     url: 'topic/299',
        // },
        {
            pr: 'ملات اندودکاری (اندود نهایی)',
            en: 'Finishing Mortar',
            img: require('@/assets/images/mortar/finishing-mortar.jpg'),
            url: 'topic/298',
        },
        {
            pr: 'ملات عایق رطوبت',
            en: 'Waterproof Mortar',
            img: require('@/assets/images/mortar/water-proof.jpg'),
            url: 'topic/297',
        },
        {
            pr: 'چسب کاشی و سرامیک',
            en: 'Tile and Ceramic Adhesiveُ',
            img: require('@/assets/images/mortar/tile-and-ceramic.jpg'),
            url: 'topic/296',
        },
        {
            pr: 'چسب آجرنما',
            en: 'Facade Brick Adhesive',
            img: require('@/assets/images/mortar/facade-brick.jpg'),
            url: 'topic/303',
        },
        // {
        //     pr: 'ملات بنایی',
        //     en: 'Building Plaster',
        //     img: require('@/assets/images/light_blocks_products/heat.jpeg'),
        //     url: 'topic/302',
        // },
        {
            pr: 'گروه صنعتی منبسط شونده',
            en: 'Cement Expending Grout',
            img: require('@/assets/images/mortar/cement-expanding.jpg'),
            url: 'topic/301',
        },
        {
            pr: 'پودر بندکشی',
            en: 'Binding Powder',
            img: require('@/assets/images/mortar/band-keshi.jpg'),
            url: 'topic/300',
        },
    ],
    blockSlider: {},
    productDetails: {},
    loading: false,
    error: {},
    blockNewsSlider:[],
    blockHomeBanner: {},
    BlockHomeNewBanner: {},
    blockHomeCatalogue: {},
    blockHomeFeatures: {},
    blockNews: {},
    blockProjects: null,
    blockProducts: [
        {
            photo_file: require('@/assets/images/lightBlocks/fake.png'),
            title: 'بلوک سبک',
            route: 'block',
            en: 'block',
            url: 'topic/88',
            sub:[],
            details: '<span lang="FA" b="" nazanin";mso-fareast-font-family:"times="" new="" roman";="" mso-fareast-language:x-none"="" style="font-size: 14pt; line-height: 21.4667px;">بلوک سبک بتنی اتوکلاو شده، نوعی بتن گازی متخلخل است.&nbsp;</span><span lang="FA" b="" nazanin""="" style="font-size: 14pt; line-height: 21.4667px;">وزن مخصوص و بسیار پایینی دارد، نصب و اجرای آن بسیار آسان و سریع بوده و&nbsp;</span>'
        },
        {
            photo_file: require('@/assets/images/light_blocks_products/heat.jpeg'),
            title: 'ملات خشک',
            route: 'malat',
            en: 'malat',
            sub:[
                {
                    pr: 'ملات عایق حرارت',
                    en: 'Heat Resistant Plaster',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/295',
                },
                {
                    pr: 'ملات اندودکاری (آستر)',
                    en: 'Plaster Mortar',
                    img: require('@/assets/images/mortar/plaster-mortar.jpg'),
                    url: 'topic/294',
                },
                {
                    pr: 'ملات خود تراز شونده',
                    en: 'Self-leveling Mortar',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/293',
                },
                {
                    pr: 'چسب بلوک سبک AAC',
                    en: 'AAC',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/292',
                },
                {
                    pr: 'ملات ضد حریق',
                    en: 'Fireproof Mortar',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/299',
                },
                {
                    pr: 'ملات اندودکاری (اندود نهایی)',
                    en: 'Finishing Mortar',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/298',
                },
                {
                    pr: 'ملات عایق رطوبت',
                    en: 'Waterproof Mortar',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/297',
                },
                {
                    pr: 'چسب کاشی و سرامیک',
                    en: 'Tile and Ceramic Adhesiveُ',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/296',
                },
                {
                    pr: 'چسب آجرنما',
                    en: 'Facade Brick Adhesive',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/303',
                },
                {
                    pr: 'ملات بنایی',
                    en: 'Building Plaster',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/302',
                },
                {
                    pr: 'گروه صنعتی منبسط شونده',
                    en: 'Cement Expending Grout',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/301',
                },
                {
                    pr: 'پودر بندکشی',
                    en: 'Binding Powder',
                    img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                    url: 'topic/300',
                },
            ],
            details: '<span lang="FA" b="" nazanin";mso-fareast-font-family:"times="" new="" roman";="" mso-fareast-language:x-none"="" style="font-size: 14pt; line-height: 21.4667px;">بلوک سبک بتنی اتوکلاو شده، نوعی بتن گازی متخلخل است.&nbsp;</span><span lang="FA" b="" nazanin""="" style="font-size: 14pt; line-height: 21.4667px;">وزن مخصوص و بسیار پایینی دارد، نصب و اجرای آن بسیار آسان و سریع بوده و&nbsp;</span>'
        },
        {
            photo_file: 'https://ardakanglass.com/uploads/topics/16448340838920.jpg',
            title: 'آجر سیلیکان',
            route: 'ajor',
            en: 'ajor',
            url: 'topic/305',
            sub:[],
            details: '<span lang="FA" b="" nazanin";mso-fareast-font-family:"times="" new="" roman";="" mso-fareast-language:x-none"="" style="font-size: 14pt; line-height: 21.4667px;">بلوک سبک بتنی اتوکلاو شده، نوعی بتن گازی متخلخل است.&nbsp;</span><span lang="FA" b="" nazanin""="" style="font-size: 14pt; line-height: 21.4667px;">وزن مخصوص و بسیار پایینی دارد، نصب و اجرای آن بسیار آسان و سریع بوده و&nbsp;</span>'
        },
    ],
    companyIntro: {},
    exports: {},
    management: {},
    buildStructure: {},
    representation: {},
    agencies: {},
    agenciesForm: {},
    blockArticles: {},
    blockCertificates: {},
    blockEvents: {},
    blockGallery: {},
    blockBanners: null,
}

const actions = {
    async getBlockSlider({commit}, payload) {
        try {
            commit('setLoading', true);
            const response = await getApi('category/138/page/1/count/10');

            commit('setBlockSlider', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getProductDetails({commit}, payload) {
        try {
            commit('setLoading', true);
            const response = await getApi(payload['url'].url);

            commit('setProductDetails', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockBanners({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/53/page/1/count/1000');
            commit('setBlockBanners', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockHomeBanner({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/138/page/1/count/100');
            console.log(response.data);
            commit('setBlockHomeBanner', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockHomeNewBanner({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('categories/8');
            commit('setBlockHomeNewBanner', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockHomeCatalogue({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/38/page/1/count/100');
            commit('setBlockHomeCatalogue', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockHomeFeatures({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/37/page/1/count/100');
            commit('setBlockHomeFeatures', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockNews({commit}, payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/39/page/${payload.page}/count/${limit}`);
            commit('setBlockNews', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockEvents({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/46/page/${payload.page}/count/${limit}`);
            commit('setBlockEvents', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockGallery({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/47/page/${payload.page}/count/${limit}`);
            commit('setBlockGallery', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockArticles({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/48/page/${payload.page}/count/${limit}`);
            commit('setBlockArticles', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockNewsSlider({commit}){
        commit('setLoading', true);
        try {
            const response = await getApi('category/208/page/1/count/100');
            state.blockNewsSlider=response.data;
        }
        catch (e) {
            commit('setError',e.response.message);
        }
        finally {
            commit('setLoading', false);
        }
    },
    
    async getBlockCertificates({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/49/page/${payload.page}/count/${limit}`);
            commit('setBlockCertificates', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockProjects({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/40/page/${payload.page}/count/${limit}`);
            commit('setBlockProjects', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockProducts({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/23/page/1/count/100');
            commit('setBlockProducts', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getCompanyIntro({commit}) {
        commit('setLoading', true);
        try {
            // const response = await getApi('category/42/page/1/count/100');
            const response = await getApi('category/215/page/1/count/100');

            commit('setCompanyIntro', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getManagement({commit}) {
        commit('setLoading', true);
        try {
            // const response = await getApi('category/45/page/1/count/100');
            const response = await getApi('category/216/page/1/count/100');

            commit('setManagement', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getFeatures({commit,state}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topics/20/page/1/count/100');
            state.block_features=response.data.topics;
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBlockExport({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/217/page/1/count/100');
            commit('setBlockExport', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getBuildStructure({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/44/page/1/count/100');
            console.log(response.data.topics);
            commit('setBuildStructure', response);
            return response.data.topics;
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getAgenciesDetails({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topic/93');
            commit('setAgenciesDetails', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getAgenciesForm({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topics/23/fields');
            commit('setAgenciesForm', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getRepresentation({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/46/page/1/count/100');
            commit('setRepresentation', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
}

const mutations = {
    setBlockSlider(state, resource) {
        state.blockSlider = resource.data.topics;
    },
    setProductDetails(state, resource) {
        state.productDetails = resource.data.topic[0];
    },
    setBlockBanners(state, resource) {
        state.blockBanners = resource.data.topics;
    },
    setBlockHomeBanner(state, resource) {
        state.blockHomeBanner = resource.data.topics;
    },
    setBlockHomeNewBanner(state, resource) {
        state.BlockHomeNewBanner = resource.data.categories;
    },
    setBlockHomeCatalogue(state, resource) {
        state.blockHomeCatalogue = resource.data;
    },
    setBlockHomeFeatures(state, resource) {
        state.blockHomeFeatures = resource.data;
    },
    setBlockNews(state, resource) {
        state.blockNews = resource.data;
    },
    setBlockEvents(state, resource) {
        state.blockEvents = resource.data;
    },
    setBlockGallery(state, resource) {
        state.blockGallery = resource.data;
    },
    setBlockProjects(state, resource) {
        state.blockProjects = resource.data;
    },
    setBlockProducts(state, resource) {
        state.blockProducts = resource.data.topics;
    },
    setCompanyIntro(state, resource) {
        state.companyIntro = resource.data;
    },
    setManagement(state, resource) {
        state.management = resource.data;
    },
    setBlockExport(state, resource) {
        state.exports = resource.data;
    },
    setBuildStructure(state, resource) {
        state.buildStructure = resource.data.topics;
    },
    setRepresentation(state, resource) {
        state.representation = resource.data;
    },
    setAgenciesDetails(state, resource) {
        state.agencies = resource.data;
    },
    setAgenciesForm(state, resource) {
        state.agenciesForm = resource.data.data;
    },
    setBlockArticles(state, resource) {
        state.blockArticles = resource.data;
    },
    setBlockCertificates(state, resource) {
        state.blockCertificates = resource.data;
    },


    setLoading(state, loading) {
        state.loading = loading;
    },
    setError(state, error) {
        state.error = error;
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}